export default __webpack_public_path__ + "static/media/admin-reports-active.9a3902fe.svg";